import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _AppointmentGroupManual } from '../../../../core/services/dataBean/EntityCatalog';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const AppointmentGroupManualEditor = ({ idSelector, onChange, label }: Props) => {

    const appointmentGorupManual = useDataBean(_AppointmentGroupManual)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(null);

    useEffect(() => {
        setID(idSelector);
        getLista();
    }, [])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {
        appointmentGorupManual.instance.getAppointmentGroupManualCatalog().then(
            (resp) => {
                setLista(resp)
                if (resp.length > 0 && !idSelector) {
                    setID(resp[0].DataBeanProperties.IDAppointmentGroupManual)
                }
            }
        )
    }

    return (
        <>
            <label>{label ?? "Tipos de Manual de Funciones:"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                {/* <option value={null}>...</option> */}
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDAppointmentGroupManual} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}